
 
  <div class="reportContainer fullViewCont">
   
    <div  class="attenLeftSec">
       <!-- <div *ngIf="userData && userData.userType != userTypeMap.FIELD_USER" class="attendCardSec"> -->
         <div *ngIf="false" class="attendCardSec">
         <ul class="attendCards scroll-touch">
             <li>
                <h6>Employee's Count</h6>
                <h4 class="green">1000</h4>
             </li>
             <li>
                <h6>Present</h6>
                <h4 class="green">950</h4>
             </li>
             <li>
                <h6>Late Comers</h6>
                <h4 class="orange">27</h4>
             </li>
             <li>
                <h6>Absent</h6>
                <h4 class="red">50</h4>
             </li>
          </ul>
       </div>
       <div class="customContainer">
          <div class="navDiv">
          <ul class="nav nav-pills scroll-touch">
           <li [routerLink]="['my-attendance']" >
               <a href="#" routerLinkActive="active">My Attendance</a>
           </li>
           <li *ngIf="userData && userData.userType != userTypeMap.FIELD_USER" [routerLink]="['team-attendance']">
               <a href="#" routerLinkActive="active">Team Attendance</a>
           </li>
           <li *ngIf="userData && userData.userType != userTypeMap.FIELD_USER" [routerLink]="['team-leave-approval']">
               <a href="#" routerLinkActive="active">Team Leave Approval</a>
           </li>
           <li [routerLink]="['leave-summary']">
               <a href="#" routerLinkActive="active">Leave Summary</a>
           </li>
           <!-- <li [routerLink]="['employee-count']">
               <a href="#" routerLinkActive="active">Employees Count By Team</a>
           </li> -->
          </ul>
          </div>
          <div class="tab-content">
      
           <router-outlet></router-outlet>
      
    </div>
       </div>
    </div>
    <div class="attenOverlay"></div>
    <div  class="attenRightSec">
       <div class="rightBox" id="birthdayBox">
          <h3>Birthday <span class="tcount">3</span></h3>
          <div class="attendRightScroll mCustomScrollbar" data-mcs-theme="minimal-dark">
             <ul class="attenRightList">
                <li>
                   <div class="attendBoxPic"><img src="assets/img/pic.jpg" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Surbhi Mittal</h4>
                      <p>has birthday today</p>
                      <button type="button" class="btn btn-default ripple lineBlueBtn">Wish Her</button>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/pic01.jpg" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Lok Priya Sagar</h4>
                      <p>has birthday today</p>
                      <button type="button" class="btn btn-default ripple lineBlueBtn">Wish Him</button>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/pic01.jpg" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Lok Priya Sagar</h4>
                      <p>has birthday today</p>
                      <button type="button" class="btn btn-default ripple lineBlueBtn">Wish Him</button>
                   </div>
                </li>
             </ul>
          </div>
       </div>
       <div *ngIf="userData && userData.userType != userTypeMap.FIELD_USER" class="rightBox leaveBox" id="emLeaveBox">
          <h3>Employees on Leave <span class="tcount">15</span></h3>
          <div class="attendRightScroll mCustomScrollbar" data-mcs-theme="minimal-dark">
             <ul class="attenRightList">
                <li>
                   <div class="attendBoxPic"><img src="assets/img/pic.jpg" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Surbhi Mittal</h4>
                      <p>Health is not good</p>
                      <div class="leaveTags">
                         <span class="attendtagsDiv blueTag">Flexi</span>
                         <span class="attendtagsDiv pinkTag">Unplanned</span>
                      </div>
                      <span class="statusText">Only Today</span>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/aakash.png" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Aakash Manchanda</h4>
                      <p>Going on trip with my...</p>
                      <div class="leaveTags">
                         <span class="attendtagsDiv blueTag">Casual Leave</span>
                         <span class="attendtagsDiv blueTag">Planned</span>
                      </div>
                      <span class="statusText">1 Jan to 11 Jan</span>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/pic.jpg" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Surbhi Mittal</h4>
                      <p>Health is not good</p>
                      <div class="leaveTags">
                         <span class="attendtagsDiv blueTag">Flexi</span>
                         <span class="attendtagsDiv pinkTag">Unplanned</span>
                      </div>
                      <span class="statusText">Only Today</span>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/aakash.png" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Aakash Manchanda</h4>
                      <p>Going on trip with my...</p>
                      <div class="leaveTags">
                         <span class="attendtagsDiv blueTag">Flexi</span>
                         <span class="attendtagsDiv blueTag">Planned</span>
                      </div>
                      <span class="statusText">1 Jan to 11 Jan</span>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/pic.jpg" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Surbhi Mittal</h4>
                      <p>Health is not good</p>
                      <div class="leaveTags">
                         <span class="attendtagsDiv blueTag">Flexi</span>
                         <span class="attendtagsDiv pinkTag">Unplanned</span>
                      </div>
                      <span class="statusText">Only Today</span>
                   </div>
                </li>
                <li>
                   <div class="attendBoxPic"><img src="assets/img/aakash.png" alt=""></div>
                   <div class="attendBoxDiv">
                      <h4>Aakash Manchanda</h4>
                      <p>Going on trip with my...</p>
                      <div class="leaveTags">
                         <span class="attendtagsDiv blueTag">Flexi</span>
                         <span class="attendtagsDiv blueTag">Planned</span>
                      </div>
                      <span class="statusText">1 Jan to 11 Jan</span>
                   </div>
                </li>
             </ul>
          </div>
       </div>
    </div>
 </div>

 